module.exports = __webpack_public_path__ + "static/media/spinner-logo.a9054526.png";